import { useState } from 'react'
import { useAppDispatch } from '@/store/store-hooks'
import { openGlobalToast } from '@/store/slices/global-toast.slice'
import { GlobalToastType, kToastDurationShortMs } from '@/constants/constants-ui'
import { downloadLrrAsDocx } from '../fetch/download-lrr-as-docx'

export function useDownloadLrrAsDocx() {
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const download = async (sanitizedHtml: string, fileName: string) => {
    setIsLoading(true)
    try {
      await downloadLrrAsDocx(sanitizedHtml, fileName)
      dispatch(openGlobalToast({ type: GlobalToastType.SUCCESS, message: `${fileName} downloaded`, durationMs: kToastDurationShortMs }))
    } catch (error) {
      dispatch(openGlobalToast({ type: GlobalToastType.ERROR, message: 'Reference download failed', durationMs: kToastDurationShortMs }))
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  return { downloadAsDocx: download, isDownloading: isLoading }
}
